module.exports = __webpack_public_path__ + "img/weingespritzt.ab29c98b.jpg";